import React from "react";
import VTCheckInDancer from "../page/VTCheckInDancer";

export default function LandingDancerCheckin({page}) {
    return (
        <>
            <VTCheckInDancer/>
        </>
    );
}